export default __webpack_public_path__ + "static/media/joys550_product.1bce3d2d.png";